module.exports = __webpack_public_path__ + "static/media/optionsIcon.9f73858c.svg";